import { updateOrderStatus } from "services/order"
import { TResultContext } from "./types"

export const services = {
    updateOrderStatus: (ctx: TResultContext) => {
        const { params } = ctx
        return updateOrderStatus(params)
    }
}